import { useState } from 'react';

export default () => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [open, setOpen] = useState(false);

	const handleOpen = (
		event: React.MouseEvent<HTMLButtonElement | HTMLDivElement | SVGSVGElement>,
	) => {
		setAnchorEl(event.currentTarget as HTMLElement);
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return { anchorEl, open, handleOpen, handleClose };
};
